import { Component, OnInit, Input, EventEmitter, Output, ElementRef, AfterViewInit } from '@angular/core';
import { SchedulerDate } from '../list/schedulerDate';
import { TranslateService } from '@ngx-translate/core';
import { SchedulerHistoryService } from '../service/scheduler.history.service';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {default as _rollupMoment, Moment} from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';

const moment = _rollupMoment || _moment;

@Component({
	selector: 'app-scheduler-calendar',
	templateUrl: './calendar.component.html',
	styleUrls: ['./calendar.component.scss']
})
export class SchedulerCalendarComponent implements OnInit, AfterViewInit {

	constYear: string;
	constMonth: string;
	constDay: string;

	days = [] as SchedulerDate[];

	_selectedDate: any;
	@Input() set selectedDate(_selectedDate: any) {
		const oldDate = this._selectedDate;

		if (_selectedDate instanceof Date) {
			this._selectedDate = _selectedDate;
		} else {
			this._selectedDate = new Date(_selectedDate.year(), _selectedDate.month(), _selectedDate.date());
		}

		if (_selectedDate) {
			if (!oldDate 
				|| !(this._selectedDate.getFullYear() === oldDate.getFullYear() 
					&& this._selectedDate.getMonth() === oldDate.getMonth() 
					&& this._selectedDate.getDate() === oldDate.getDate())) {
				this.doResetDays(this._selectedDate);
				this.dateChanged.emit(this._selectedDate);
			}
		}
	}
	get selectedDate(): any {
		return this._selectedDate;
	}

	daysHeight = "0px";

	selectedDateText: string;
	weekdays = {};
	weekdaysArray = [];
	monthStr = [ 'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC' ];

	@Input() viewFormat = 'Month';
	
	_schedules: any[];
	@Input() set schedules(_schedules: any[]) {
		this._schedules = _schedules;
	}
	get schedules() {
		return this._schedules;
	}

	@Input() isDashboard = false;

	@Output() dateChanged = new EventEmitter<any>();
	@Output() viewChanged = new EventEmitter<any>();
	@Output() schedulerSelected = new EventEmitter<any>();

	constructor(
		private schedulerHistoryService: SchedulerHistoryService,
		private translateService: TranslateService,
		private calendarElement: ElementRef
	) {
		this.selectedDate = new Date();
	}

	ngOnInit() {
		this.translateService.get(['service.scheduler.list.content.weekdays.SUN',
		'service.scheduler.list.content.weekdays.MON',
		'service.scheduler.list.content.weekdays.TUE',
		'service.scheduler.list.content.weekdays.WED',
		'service.scheduler.list.content.weekdays.THR',
		'service.scheduler.list.content.weekdays.FRI',
		'service.scheduler.list.content.weekdays.SAT']).subscribe((messages: any) => {
			this.weekdays['SUN'] = messages['service.scheduler.list.content.weekdays.SUN'];
			this.weekdays['MON'] = messages['service.scheduler.list.content.weekdays.MON'];
			this.weekdays['TUE'] = messages['service.scheduler.list.content.weekdays.TUE'];
			this.weekdays['WED'] = messages['service.scheduler.list.content.weekdays.WED'];
			this.weekdays['THR'] = messages['service.scheduler.list.content.weekdays.THR'];
			this.weekdays['FRI'] = messages['service.scheduler.list.content.weekdays.FRI'];
			this.weekdays['SAT'] = messages['service.scheduler.list.content.weekdays.SAT'];

			this.weekdaysArray = [];
			for (const weekday of Object.keys(this.weekdays)) {
				this.weekdaysArray.push(weekday);
			}
		});
	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.doResetDays(this._selectedDate);
			this.onDaysResized();
		}, 500);
	}

	_refreshDays() {
		const selectedDate = this.selectedDate;
		let fromDate = null as Date;
		let toDate = null as Date;
		
		if (this.viewFormat === 'Day') {
			fromDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0);
			toDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 23, 59, 59);
		} else if (this.viewFormat === 'Week') {
			let currentDay = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
			fromDate = new Date(currentDay.setDate(currentDay.getDate() - selectedDate.getDay()));
			toDate = new Date(currentDay.setDate(currentDay.getDate() + 7));
		} else {
			let nextMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1);
			fromDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1, 0, 0, 0);
			toDate = new Date(nextMonth.setDate(nextMonth.getDate() - 1));
		}

		if (this.schedules) {
			this.schedules.forEach((schedule: any) => {
				schedule.taskHistory = [];
			});
		}

		if (this.schedules) {
			this.schedulerHistoryService.list('', fromDate.toUTCString(), toDate.toUTCString()).subscribe((histories: any) => {
				histories.forEach((history: any) => {
					if (history.group) {
						this.schedules.forEach((schedule: any) => {
							if (history.group.id === schedule.id) {
								if (!schedule.taskHistory) {
									schedule.taskHistory = [];
								}
								schedule.taskHistory.push(history);
							}
						});
					}
				});
	
				if (this.schedules && this.days) {
					this.days.forEach((day: SchedulerDate) => {
						day.refreshRules(this.schedules);
					});
				}
			});	
		}
	}

	onDaysResized() {
		const currentHeight = parseInt(this.calendarElement.nativeElement.offsetHeight) - (this.isDashboard ? 60 : 86);

		if (currentHeight > 0) {
			this.daysHeight = currentHeight + "px";

			const weekCount = this.days.length / 7;
			const weekHeight = parseInt((currentHeight-(30 + 3 * weekCount)) / weekCount + '');

			document.documentElement.style.setProperty('--scheduleDateHeight', weekHeight + 'px');
		}
	}

	doResetDays(selectedDate: Date) {
		if (this.viewFormat === 'Day') {
			this.translateService.get('service.scheduler.list.content.format.day', { 
				year: selectedDate.getFullYear(), 
				month: selectedDate.getMonth() + 1, 
				day: selectedDate.getDate(),
				weekday: this.weekdays[SchedulerDate._getWeekDay(selectedDate)]
			 })
			.subscribe((message: string) => {
				this.selectedDateText = message;
			});
			this.days = [];
			for (let index = 0; index < 24; index ++) {
				this.days.push(new SchedulerDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), index), this.viewFormat));
			}
		} else if (this.viewFormat === 'Week') {
			this.translateService.get('service.scheduler.list.content.format.week', {
				year: selectedDate.getFullYear(),
				month: selectedDate.getMonth() + 1,
				day: selectedDate.getDate() })
			.subscribe((message: string) => {
				this.selectedDateText = message;
			});
			this.days = [];
			for (let index = 0; index < selectedDate.getDay(); index ++) {
				let currentDay = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
				this.days.push(new SchedulerDate(new Date(currentDay.setDate(currentDay.getDate() - selectedDate.getDay() + index)), this.viewFormat));
			}
			for (let index = selectedDate.getDay(); index < 7; index ++) {
				let currentDay = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
				this.days.push(new SchedulerDate(new Date(currentDay.setDate(currentDay.getDate() + index - selectedDate.getDay())), this.viewFormat));
			}
		} else {
			this.translateService.get('service.scheduler.list.content.format.month', {
				year: selectedDate.getFullYear(),
				month: selectedDate.getMonth() + 1,
				day: selectedDate.getDate(),
				monthStr: this.monthStr[selectedDate.getMonth()]
			})
			.subscribe((message: string) => {
				this.selectedDateText = message;
			});
			let firstDayOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
			let lastDayOfMonth = new Date(firstDayOfMonth.setMonth(selectedDate.getMonth() + 1));
	
			firstDayOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
			lastDayOfMonth = new Date(lastDayOfMonth.setDate(lastDayOfMonth.getDate() - 1));
	
			this.days = [];
			for (let index = 0; index < firstDayOfMonth.getDay(); index ++) {
				let currentDay = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth(), firstDayOfMonth.getDate());
				this.days.push(new SchedulerDate(new Date(currentDay.setDate(currentDay.getDate() - firstDayOfMonth.getDay() + index)), this.viewFormat));
			}
			for (let index = 0; index < lastDayOfMonth.getDate(); index ++) {
				this.days.push(new SchedulerDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth(), index + 1), this.viewFormat));
			}
			for (let index = lastDayOfMonth.getDay(); index < 6; index ++) {
				let currentDay = new Date(lastDayOfMonth.getFullYear(), lastDayOfMonth.getMonth(), lastDayOfMonth.getDate());
				this.days.push(new SchedulerDate(new Date(currentDay.setDate(lastDayOfMonth.getDate() + index + 1 - lastDayOfMonth.getDay())), this.viewFormat));
			}
		}
		if (this.days) {
			this._refreshDays();
		}
	}

	viewPrev() {
		const currentDate = new Date(this.selectedDate);

		if (this.viewFormat === 'Month') {
			this.selectedDate = new Date(currentDate.setMonth(currentDate.getMonth() - 1));
		} else if (this.viewFormat === 'Week') {
			this.selectedDate = new Date(currentDate.setDate(currentDate.getDate() - 7));
		} else if (this.viewFormat === 'Day') {
			this.selectedDate = new Date(currentDate.setDate(currentDate.getDate() - 1));
		}
		this.onDaysResized();
	}

	viewToday() {
		this.selectedDate = new Date();
		this.onDaysResized();
	}

	viewNext() {
		const currentDate = new Date(this.selectedDate);
		
		if (this.viewFormat === 'Month') {
			this.selectedDate = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
		} else if (this.viewFormat === 'Week') {
			this.selectedDate = new Date(currentDate.setDate(currentDate.getDate() + 7));
		} else if (this.viewFormat === 'Day') {
			this.selectedDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
		}
		this.onDaysResized();
	}

	onViewChanged() {
		this.viewChanged.emit(this.viewFormat);
		this.doResetDays(this.selectedDate);
	}

	onSchedulerSelected(scheduler: any) {
		this.schedulerSelected.emit(scheduler);
	}

	chosenYearHandler(normalizedYear: Moment) {
		this.selectedDate.setFullYear(normalizedYear.year());
	}
	
	chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
		const date = new Date(normalizedMonth.year(), normalizedMonth.month(), 1, 0, 0, 0);
		datepicker.close();

		this.selectedDate = date;
		this.doResetDays(this.selectedDate);
	}
}
